import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';
import doodlePromotionMobile from '~/assets/icons/doodlePromotionMobile.svg';
import CarPageBackground from '~/assets/images/carPageBackground.svg';
import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

const useStyles = () => ({
  root: {
    paddingBottom: '3px',
    padding: '0 20px',
    marginTop: '71px',
    [theme.breakpoints.up('md')]: {
      paddingBottom: '80px',
      marginTop: '70px',
    },
  },
  desktopWrapper: {
    width: '636px',
    position: 'relative',
  },
  backStyle: {
    '& svg': {
      cursor: 'pointer',

      '&::hover': {
        transform: 'translateX(-1rem)',
      },
    },
  },
  mobileWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    padding: '0px 20px 20px 20px',
  },
  shareAndFavWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  heartWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50px',
    height: '40px',
    '&:hover': {
      backgroundColor: COLORS.primary.light2,
    },
    borderRadius: '20px',
  },
  carDetailsPlaceHolder: {
    width: '440px',
  },
  stickyDetailsBlockStyle: {
    position: 'sticky',
    top: '100px',
    width: '400px',
  },
  customImageStyle: {
    width: '656px',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
    position: 'fixed',
  },
  imageSliderWrapper: {
    position: 'relative',
    marginTop: '8px',
  },
  topLabelStyles: {
    position: 'absolute',
    top: '0',
    right: '0',
    zIndex: '9',
    marginRight: '-20px',
    [theme.breakpoints.up('md')]: {
      marginRight: 'unset',
    },
  },
  btnBackwardsDesktop: {
    position: 'relative',
    right: '-10px',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      right: '0px',
      top: '-35px',
    },
  },
  promotionStyle: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      backgroundImage: `url(${CarPageBackground.src})`,
      backgroundSize: 'contain',
      objectFit: 'contain',
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: '0',
    },
  },
  doodleMobile: {
    backgroundImage: `url(${doodlePromotionMobile.src})`,
    height: '150px',
    width: '150px',
    position: 'absolute',
    backgroundRepeat: 'no-repeat',
    top: '-10px',
    right: '40px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolTipButton: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    alignItems: 'initial',
    border: 'none',
    '& span': {
      textDecoration: 'underline',
    },
  },
  purchasePlanContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  shareWithModelNameWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: '20px',
    marginBottom: '15px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },

    '& svg': {
      cursor: 'pointer',
    },
  },
  desktopBrandName: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    [theme.breakpoints.up('md')]: {
      width: '100%',
      maxWidth: '1130px',
      margin: '0 auto',
    },
  },
  backButtonInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '8px',
  },
  backButtonText: { fontSize: '16px' },
  contentContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '1130px',
    margin: '0 auto',
  },
  breadcrumbs: {
    width: '100%',
    maxWidth: '1130px',
    margin: '0 auto',
  },
  bottomHighlightLabel: {
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  customCompareButton: {
    width: 'max-content',
    backgroundColor: 'transparent !important',
    border: 'unset',
    zIndex: '1',
    minWidth: 'auto',
    transition: 'transform 0.3s ease',

    '&:hover': {
      backgroundColor: `${COLORS.primary.light2} !important`,
    },
    borderRadius: '20px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingInline: '16px',

    '& svg': {
      width: '25px',
      marginLeft: '8px',

      '& path': {
        transition: 'transform 0.3s ease',
        transformOrigin: 'center',
      },
    },

    '&:hover path:first-of-type': {
      transform: 'translateX(-3px)',
      transition: 'transform 0.3s ease',
    },
    '&:hover path:last-of-type': {
      transform: 'translateX(3px)',
      transition: 'transform 0.3s ease',
    },

    [theme.breakpoints.down('md')]: {
      '& svg': {
        width: '20px',
        marginLeft: '0px',
      },
    },
  },
  customIsCompareButton: {
    '& path:last-of-type': {
      stroke: `${COLORS.primary.main}`,
      transition: 'transform 0.3s ease',
    },
  },
});

export default useStyles;

export const yellowLineLabel = styled('svg')(() => ({
  position: 'absolute',
  right: '0',
  bottom: '0',
  zIndex: '-1',
}));

export const StyledBackButton = styled('svg')(() => ({
  width: '14px',
}));

export const btnBackwardsDesktop = styled('svg')(() => ({
  position: 'relative',
  right: '-10px',
  cursor: 'pointer',
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    right: '0px',
    top: '-35px',
  },
}));

export const mobileView = {
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
};

export const desktopView = {
  display: 'none',
  [theme.breakpoints.up('md')]: {
    position: 'relative',
    display: 'flex',
    padding: '24px 0 0',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '17px',
  },
};

export const brandNameStyle = {
  fontSize: '18px',
  fontFamily: 'EricaSansFOT, GillSans !important',
  fontWeight: '400',
  color: COLORS.gray.dark,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '20px',
  [theme.breakpoints.up('md')]: {
    gap: '17px',
    justifyContent: 'flex-start',
    marginTop: '12px',
    color: COLORS.gray.dark,
  },
};
export const brandAndModelNameStyle = {
  fontSize: '18px',
  fontFamily: 'EricaSansFOT, GillSans !important',
  fontWeight: '400',
  color: COLORS.gray.dark,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
    marginTop: '12px',
    color: COLORS.gray.dark,
    alignItems: 'flex-start',
  },
};

export const modelNameStyle = {
  marginTop: '8px',
  marginBottom: '3px',
  fontSize: '24px',
  maxWidth: '210px',
  lineHeight: '24px',
  textTransform: 'uppercase',
  fontFamily: 'EricaSansFOT,GillSans',
  fontWeight: '800',
  color: COLORS.black.main,
  [theme.breakpoints.up('md')]: {
    display: 'block',
    lineHeight: '24px',
    fontSize: '24px',
  },
};
export const heStyle = {
  fontWeight: 'normal',
  fontSize: '20px',
  [theme.breakpoints.up('md')]: {
    fontSize: '24px',
  },
};
export const enStyle = {
  fontWeight: 'bold',
  fontSize: '20px',
  [theme.breakpoints.up('md')]: {
    fontSize: '24px',
  },
};

export const boxBannerPromotionDesktop = {
  marginTop: '20px',
  marginBottom: '10px',
};

export const wishlistIconStyle = {
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    cursor: 'pointer',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '150%',
    paddingInlineEnd: '16px',
  },
  '&:hover': {
    backgroundColor: COLORS.primary.light2,
  },
  borderRadius: '20px',
};
export const carCardBottomLabelStyle = {
  backgroundColor: `${COLORS.yellow.light1}`,
  width: 'fit-content',
  padding: '3px 16px',
  borderRadius: '34px 4px 4px 34px',
  fontWeight: '400',
  fontSize: '14px',
};

export const carSaleLabelStyle = {
  backgroundColor: `${COLORS.yellow.main}`,
  width: 'fit-content',
  padding: '3px 16px',
  borderRadius: '34px 4px 4px 34px',
  fontWeight: 'bold',
  fontSize: '14px',
  textTransform: 'lowercase',
};

export const LabelStyle = {
  position: 'relative',
  fontSize: '16px',
};

export const btnTextStyle = {
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    paddingRight: '18px',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '150%',
  },
};

export const typeLabelStyle = {
  backgroundColor: `${COLORS.primary.main}`,
  padding: '5px 10px',
  borderRadius: '20px',
  fontSize: '12px',
  color: `${COLORS.primary.dark}`,
  [theme.breakpoints.down('md')]: {
    width: 'fit-content',
    display: 'inline-flex',
    alignSelf: 'end',
  },
};

// Used car ?
export const CarImagesCarouselStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
} as const;

export const boxBannerPromotion = {
  marginTop: '20px !important',
  marginBottom: '20px',
};

export const CarPromotionBanner = styled('img')({
  // width: '100vw',
  maxHeight: '115px',
  objectFit: 'cover',
  display: 'block',
  [theme.breakpoints.up('md')]: {
    width: '100%',
    marginRight: '0',
  },
});

export const StyledPrioritizeBox = styled(Box)(({ theme }) => ({
  padding: '12px 8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: COLORS.gray.light,
  borderRadius: '4px',
  margin: '0 auto -15px',
  gap: '12px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    padding: '8px 12px',
    margin: '24px auto',
  },
}));

export const StyledPrioritizeTypography = styled(Typography)(({}) => ({
  fontSize: '16px',
}));
export const fomoContainer = {
  display: 'flex',
  alignItems: 'center',
  width: 'fit-content',
  position: 'absolute',
  top: '0',
  left: '0',
  zIndex: '9',
  gap: '6px',
};

export const StyledFomoIcon = styled('svg')(() => ({
  width: '24px',
  height: '24px',
}));

export const fomoText = {
  fontFamily: 'EricaSansFOT',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '14px',
  letterSpacing: '-0.02em',
  textAlign: 'left',
  color: `${COLORS.black.main}`,
};
